__turbopack_context__.v({
  "main": "layout-module__kUUZQa__main",
  "root": "layout-module__kUUZQa__root",
});
